// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1nzcs","row":"ProcedureTreatmentSummary_row__XZzoN"};